import { render, staticRenderFns } from "./TaskViewModal.vue?vue&type=template&id=1380264c&scoped=true"
import script from "./TaskViewModal.vue?vue&type=script&lang=js"
export * from "./TaskViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380264c",
  null
  
)

export default component.exports